export default {
  computed: {
    cypress() {
      return process.env.VUE_APP_CYPRESS;
    },
  },
};
